import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';

const LoginPage = () => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [formErrors, setFormErrors] = useState({ email: '', password: '' });
  const [userNameValid, setUserNameValid] = useState(false);
  const [passwordValid, setPasswordValid] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const navigate = useNavigate();

  const validateField = (fieldName, value) => {
    const fieldValidationErrors = { ...formErrors };
    let validUserName = userNameValid;
    let validPassword = passwordValid;

    switch (fieldName) {
      case 'userName':
        validUserName = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.email = validUserName ? '' : ' is invalid';
        setUserNameValid(!!validUserName);
        break;
      case 'password':
        validPassword = value.length >= 6;
        fieldValidationErrors.password = validPassword ? '' : ' is too short';
        setPasswordValid(validPassword);
        break;
      default:
        break;
    }

    setFormErrors(fieldValidationErrors);
    setFormValid(!!validUserName && validPassword);
  };

  const handleUserInput = (e) => {
    const { name, value } = e.target;
    if (name === 'userName') {
      setUserName(value);
      validateField('userName', value);
    } else if (name === 'password') {
      setPassword(value);
      validateField('password', value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoggedIn(true);
    navigate('/');
  };

  return (
    <div className='card-login'>
      <Row>
        <Col md='4' />
        <Col md='4'>
          <div className='card'>
            <div className='card-body'>
              <h5 className='card-title'>Login</h5>
              <Form onSubmit={handleSubmit}>
                <FormGroup row>
                  <Col md='2'>
                    {' '}
                    <Label for='exampleEmail'>Email</Label>
                  </Col>
                  <Col>
                    <Input
                      id='userName'
                      name='userName'
                      value={userName}
                      type='text'
                      onChange={handleUserInput}
                      placeholder='Enter username'
                    />
                    {formErrors.email && (
                      <span className='error'>{formErrors.email}</span>
                    )}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col md='2'>
                    <Label for='examplePassword'>Password</Label>
                  </Col>
                  <Col>
                    <Input
                      id='password'
                      name='password'
                      value={password}
                      type='password'
                      onChange={handleUserInput}
                    />
                    {formErrors.password && (
                      <span className='error'>{formErrors.password}</span>
                    )}
                  </Col>
                </FormGroup>
                <Input
                  id='loginButton'
                  className='btn'
                  type='submit'
                  value='Login'
                  disabled={!formValid}
                />
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LoginPage;
